import * as React from 'react';
import { Typography, useMediaQuery, useTheme } from '@mui/material';

import { SubmitButton } from 'components';
import { PasswordForm } from 'forms';
import { useAppDispatch } from 'store/store.hook';
import { updateLayout } from 'store/slices/layout.slice';

interface ProfilePasswordPageProps {}

export const ProfilePasswordPage: React.FC<ProfilePasswordPageProps> = () => {
  const theme = useTheme();
  const down_sm = useMediaQuery(theme.breakpoints.down('sm'));
  const dispatch = useAppDispatch();
  const [loading, setLoading] = React.useState<boolean>(false);
  const formRef = React.useRef<any>();
  const submitButtonLabel = down_sm ? 'Reset' : 'Reset Password';

  React.useEffect(() => {
    dispatch(updateLayout({ headerTitle: 'Change Password' }));
  }, []);

  const onSubmit = () => {
    formRef.current.onSubmit();
  };

  return (
    <div>
      <Typography variant="h5">New Password</Typography>
      <Typography sx={{ fontWeight: 'normal', marginTop: 1, marginBottom: 4, color: theme.palette.text.secondary }}>
        Your new password needs at least 6 characters.
      </Typography>

      <PasswordForm ref={formRef} onLoading={(loading) => setLoading(loading)} />

      <SubmitButton loading={loading} label={submitButtonLabel} onClick={onSubmit} sx={{ marginTop: 6 }} />
    </div>
  );
};
